import type { Reference } from '@medplum/fhirtypes'
import { featureFlags } from '@seen/core/featureFlags'
import {
  groupCurrentMedications,
  type PartitionedMedications,
  partitionMedications,
} from '@seen/core/models/currentMedications'
import { ExtendedMedicationRequest } from '@seen/core/models/medicationRequest'
import { useMemo } from 'react'
import { useFeatureFlag } from '#src/hooks/useFeatureFlag.ts'
import { useSearch } from '#src/hooks/useSearch.ts'

export function useCurrentMedications(
  patientReference: Reference | undefined
): PartitionedMedications & { isLoading: boolean } {
  const { data: medicationRequests = [], isLoading } = useSearch(
    ExtendedMedicationRequest,
    patientReference
      ? {
          patient: patientReference,
          _sort: '-_lastUpdated',
          _count: 1000,
          'status:not': ['entered-in-error', 'draft'],
        }
      : undefined
  )

  const shouldGroupByElationThread = useFeatureFlag(
    featureFlags.medicationGroupByElationThread
  )
  const partitioned = useMemo(
    () =>
      partitionMedications(
        groupCurrentMedications(medicationRequests, {
          groupByElationThread: shouldGroupByElationThread,
        })
      ),
    [medicationRequests, shouldGroupByElationThread]
  )

  return {
    ...partitioned,
    isLoading,
  }
}
